$(document).ready(function() {

  $(document).on('click', '.toggle .toggle__pill', function() {

    const toggleSwitch = $(this).closest('.toggle').find('.toggle__switch');
    const toggleTitle = $(this).closest('.toggle').find('.toggle__title');
    const toggle = $(this).closest('.toggle')
    const toggleAttr = toggle.attr('active') === 'true'


    if (toggleAttr) {
      $(this).removeClass('active')
      toggleSwitch.removeClass('active')
      toggle.attr('active', false)
      // Toggle title
      toggleTitle.find('.active').addClass('d-none')
      toggleTitle.find('.non-active').removeClass('d-none')
    } else {
      $(this).addClass('active')
      toggleSwitch.addClass('active')
      toggle.attr('active', true)
      // Toggle title
      toggleTitle.find('.active').removeClass('d-none')
      toggleTitle.find('.non-active').addClass('d-none')
    }
  })
})